import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import FailedAccountHeader from './failedAccountHeader';
import overlayClasses from "./confOverlaystyles.scss";
import classes from "./BulkEnrollConfPopup.scss";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
import FocusTrap from 'focus-trap-react';
class BulkEnrollConfPopup extends React.Component {

    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.strings = getLocalizedStrings("PbConfPopup");
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    }

    componentDidMount() {
       
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
       this.props.isConfOpen();
       
    
        }
     } 
    doneButtonHandler() {
        this.props.isConfOpen();
        this.props.isOpen();
        window.location.reload();
    }
   
    render() {
        const failedAccountDisplay= <div>
        {this.props.contractAccountResults.map((data,index) => {
                for(let i=0;i<this.props.failedAccounts.length;i++){
                let accountNumber=this.props.failedAccounts[i];
                if(data.contractAccountNumber===accountNumber){
                    return(
                        <div>
                            <FailedAccountHeader accountData={data} />
                        </div>
                    );
                }  
            }
           })} 
        </div>;
        
        return (
            <FocusTrap 
            focusTrapOptions={{
               allowOutsideClick: true,
           }}
           >
            <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div  ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                            <div className='row'>
                               
                                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.TurnOnPopupTitle}<button className={classes.iconClose} onClick={this.doneButtonHandler.bind(this)}><img  src={this.closeIcon} alt="Close Icon"  /> </button></div>
                                <p className={'col-xs-12 ' + classes.msgData}>
                                {this.strings.BulkEnrollTitle} {this.props.successCount} {this.strings.Of} {this.props.totalAccounts} {this.strings.Accounts}
                                </p>
                                <ul className={classes.genericData}>
                                    <li>{this.strings.GenericBillMsg}</li>
                                    <li className={classes.emailMsg}>{this.strings.Email}<span className={classes.mail}>{this.props.primaryEmail}</span></li>
                                </ul>
                            
                            </div>
                            <div className={classes.dividerLine} />
                           
                                <div className={classes.errContainer}>
                                    <div className={classes.warningImg}><img src={this.warningImg} alt="Warning Image" /></div>
                                    <div className={classes.errMsg}>
                                    {this.strings.BulkEnrollErrMsg1} {this.props.failedAccounts.length} {this.strings.BulkEnrollErrMsg2}
                                    </div> 
                               
                                </div>
                                <div className={classes.acctData}>
                                   {failedAccountDisplay} 
                                </div>
 
                        <div className={"text-align-center"}>
                            <div className={classes.footerButton}>
                                <SceButton
                                    buttonType="primary"
                                    value={this.strings.Done}
                                    onClick={this.doneButtonHandler.bind(this)}
                                />
                            </div>
                        </div>
                        </div>
                    </div>


                </div>
            </div>
            </FocusTrap>

        );
    }
}
export default BulkEnrollConfPopup;
